import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { getAuth } from 'quartz-auth/hubless/service';
import { Provider } from 'react-redux';
import { configureStore } from './utils/configureStore';
import { initializeAuth, startApp } from './actions/AppActions';
import { Routes } from './components/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const dataFetchingClient = new DataFetchingClient();
export const prepareApp = () => {
  const store = configureStore();
  store.dispatch(initializeAuth(getAuth()));
  store.dispatch(startApp());
  return {
    props: {
      store,
      client: dataFetchingClient
    }
  };
};
export function AppComponent({
  store,
  client
}) {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: client,
    children: /*#__PURE__*/_jsxs(Provider, {
      store: store,
      children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(Routes, {})]
    })
  });
}